import React from 'react';
import HighchartsReact from 'highcharts-react-official';
import 'highcharts/modules/exporting';

const Chart = ({ options, highcharts }) => (
  <HighchartsReact
    highcharts={highcharts}
    constructorType={'chart'}
    options={options}
  />
);

export default Chart;
